import DefaultValidation from "@/services/validations/DefaultValidation";
import Message from '@/models/Message';

export default class AdiantamentoValidation extends DefaultValidation{

  constructor(msgs) {
    super(msgs);
  }

  validate(model, colaborador, empresa, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (model.valor==0 || colaborador==null || model.obsgeral=='' || empresa == null) {
      refs.valorInput.focusedOut = true;
      refs.observacaoInput.focusedOut = true;
      refs.colaboradorSelect.focusedOut = true;
      refs.empresaSelectedInput.focusedOut = true;
      validated = false;
      this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
    }
    
    return validated;
  }
}